<template>
  <div>
    <main-information
      :isDetailPage="true"
      @on-submit="updateMainInfo"
      ref="formRef"
      :serverValidations="serverValidations"
    >
      <template #footer-actions v-if="$can(Class.actions.edit, Class.subject)">
        <div class="form-actions text-center">
          <md-button class="md-raised" @click="clearForm">{{
            $t("common.cancel")
          }}</md-button>
          <md-button type="submit" class="md-success ml-4">{{
            $t("common.update")
          }}</md-button>
        </div>
      </template>
    </main-information>
  </div>
</template>

<script>
import { MainInformation } from "../Forms";
import { service_paths, cms_service_paths } from "@/constants/Services";
import { Message, genErrMsgOj } from "@/helpers/utils";
import { class_router_names } from "@/routes/routes";
import { Class } from "@/constants/Permissions";
import {SYSTEM } from "@/constants/System";

export default {
  components: { MainInformation },
  data() {
    return {
      classId: this.$route.params.id,
      serverValidations: {},
      Class
    };
  },
  methods: {
    updateMainInfo(formData) {
      const errMsg = this.$t("common.form_invalid");
      this.$axios
        .put(
          `${service_paths.classes}/${this.classId}`,
          formData,
          {},
          {},
          errMsg
        )
        .then(async ({ data }) => {
          Message.success(this.$t("common.successfully"));
          let objParam = {
            ...data,
            sis_subject: (data.subject || {}).subject_display_name,
            sis_term: (data.terms || {}).name,
            id_ref: data.id,
            description: formData.description,
            program_learning_id: data.zone,
            source: SYSTEM.LMS
          } 
          await this.$axios.cms_post(`${cms_service_paths.class_update}`, [objParam], {}, {}, null, false)
        })
        .catch(error => {
          const errorMessage = error.response?.data.messages;
          if (errorMessage) {
            this.serverValidations = genErrMsgOj(errorMessage);
          }
        });
    },
    clearForm() {
      this.$refs.formRef.clearForm();
      this.$router.push({
        name: class_router_names.listPage
      });
    },

    injectFormData(classInfo) {
      this.$refs.formRef.injectFormData(classInfo);
    }
  }
};
</script>

<style lang="scss" scoped></style>
